import { IndirectTaxSummaryCard } from '../../common';
import { IndirectTaxTransactionHelper } from '../helpers';
import {
  TIndirectTaxTransactionDetail,
  TIndirectTaxTransactionRegion,
} from '../types';

interface IndirectTaxTransactionDetailSummaryProps {
  transaction: TIndirectTaxTransactionDetail;
  region: TIndirectTaxTransactionRegion;
}

const IndirectTaxTransactionDetailSummary = ({
  transaction,
  region,
}: IndirectTaxTransactionDetailSummaryProps) => {
  const configs = IndirectTaxTransactionHelper.DETAIL_SUMMARY_CONFIGS[region];
  const currencySymbol = IndirectTaxTransactionHelper.getCurrencySymbol(
    transaction.currency
  );

  return (
    <div
      className="grid grid-cols-3 m-3xl mb-none border-b"
      data-ai-section="Transaction summary"
    >
      {configs.map((config) => {
        const value = transaction[config.key];
        const numValue = typeof value === 'number' ? value : 0;

        return (
          <IndirectTaxSummaryCard
            key={config.key}
            label={`${config.label} (${currencySymbol})`}
            value={IndirectTaxTransactionHelper.formatCurrency(numValue)}
          />
        );
      })}
    </div>
  );
};

export { IndirectTaxTransactionDetailSummary };
